module.exports = __webpack_public_path__ + "media/qq.b0978009.wav";